export default {"src":"/_next/static/media/linux.369aa2f7.svg","height":512,"width":448};